import React from 'react';
import { TopBar } from './components/TopBar';
import { Header } from './components/Header';
import { CouponBanner } from './components/CouponBanner';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { BrandsStrip } from './components/BrandsStrip';
import { ShingleFocus } from './components/ShingleFocus';
import { RoofReplacement } from './components/RoofReplacement';
import { CostSection } from './components/CostSection';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { QuoteForm } from './components/QuoteForm';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { FloatingCall } from './components/FloatingCall';
export function App() {
  return <div className="min-h-screen w-full bg-white text-[#1a2332] selection:bg-[#2DB8E0]/30" data-id="element-0" data-mp="23u9t8lgjx9w8">
      <TopBar data-id="element-1" data-mp="3ikqyfyb7r257" />
      <Header data-id="element-2" data-mp="3ij64oawq3n8e" />
      <CouponBanner data-id="element-3" data-mp="3ijfthv617oci" />
      <main data-id="element-4" data-mp="3ii4su47vuwpm">
        <Hero data-id="element-5" data-mp="3mlj98vzqhf3l" />
        <BrandsStrip data-id="element-6" data-mp="3ml13n8r6loj0" />
        <TrustBar data-id="element-7" data-mp="3mkhnnxl3da7m" />
        <ShingleFocus data-id="element-8" data-mp="3mjzpuwis6nxl" />
        <RoofReplacement data-id="element-9" data-mp="3mj6hxs835sdv" />
        <CostSection data-id="element-10" data-mp="3rbr9so7flver" />
        <Process data-id="element-11" data-mp="3rdaselgk8ijp" />
        <Testimonials data-id="element-12" data-mp="3rcswjpxt86cb" />
        <QuoteForm data-id="element-13" data-mp="3reltuemj9e7n" />
        <FAQ data-id="element-14" data-mp="5otf64sd496" />
        <FinalCTA data-id="element-15" data-mp="6htxpd5ixiv" />
      </main>
      <Footer data-id="element-16" data-mp="5gel8p3rovc" />
      <StickyMobileCTA data-id="element-17" data-mp="56qjqnmbrsa" />
      <FloatingCall data-id="element-18" data-mp="2zl3bdjx5744s" />
    </div>;
}